import { DEV_MODE, STAGING_MODE } from '@/app/config/constants.ts';

export const API_URL =
  DEV_MODE || STAGING_MODE
    ? 'https://t-api.mediators.kz/api'
    : 'https://api.mediators.kz/api';

export enum STATUS {
  SUCCESS = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  CLIENT_ERRORS = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  UNPROCESSABLE = 422,
  SERVER_ERRORS = 500,
}

export enum QUERY_KEYS {
  FETCH_USER_INFO = 'FETCH_USER_INFO',
  FETCH_MEDIATIONS = 'FETCH_MEDIATIONS',
  FETCH_MEDIATION = 'FETCH_MEDIATION',
}

export const STALE_TIME_SHORT = 1200; // 1.2 sec
export const STALE_TIME_DEFAULT = 1000 * 60 * 5; // 5 min
